export default __webpack_public_path__ + "static/media/Edit2.1c18cdb1.svg";